<template>
	<a :href="item.platformUrl" target="_blank" @click="setClickData(item.tmpexbId)" class="exhibit-item-content" v-bind:class="{ closed: item.closed }">
		<div class="item-content">
			<div class="item-content-info">
				<div class="item-content-info-coupon">
					<div class="item-content-info-coupon-img">
						<span class="coupon-img-thumb">
							<img :src="item.tmpexbImgUrl" :alt="item.tmpexbImgNm" />
						</span>
					</div>
					<div class="item-content-info-coupon-desc">
						<span class="subtext">{{ item.tmpexbPfxCn }}</span>
						<span class="cpndisc">{{ item.tmpexbBodysCn }}</span>
					</div>
				</div>
				<div class="item-content-info-title">{{ item.tmpexbNm }}</div>
				<div class="item-content-info-date">{{ item.period }}</div>
			</div>
			<!-- <div class="item-content-sub">
				<span class="subtitle">{{ item.brand }}</span>
				<span class="subtext">{{ item.desc }}</span>
			</div> -->
		</div>
	</a>
</template>

<script>

import { mapGetters } from 'vuex';
import { ACT_SET_CAMPN_CLICK_DATA } from '@/store/_act_consts';

export default {
	name: 'ExhibitionItemList',
	components: {},
	props: {
		item: null,
	},
	data: () => ({}),
	computed: {
		...mapGetters('common', [ 'campn']),
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {
		setClickData(clickTrgtId) {
			// api 호출
			this.$store
				.dispatch(`common/${ACT_SET_CAMPN_CLICK_DATA}`, {
					clickTrgtId,
					clickTrgtTyp: "WNN_TMPEXB",
					campnId: this.campn.campnId,
				})
				.then((res) => {})
				.catch((e) => {
					console.error(e);
				});
		}
	},
};
</script>
